import { render, staticRenderFns } from "./dinopop.vue?vue&type=template&id=f977d266&scoped=true"
import script from "./dinopop.vue?vue&type=script&lang=js"
export * from "./dinopop.vue?vue&type=script&lang=js"
import style0 from "./dinopop.vue?vue&type=style&index=0&id=f977d266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f977d266",
  null
  
)

export default component.exports